module.exports = __webpack_public_path__ + "img/Icon_Mind2_RZ_rgb.d6ab1ca5.png";